import { EsquireClient } from "@/types/clients/esquire";
import Passport, {PassportData} from "@/types/clients/esquire/data/general/passport";

export default class GetPassport {
  constructor(private client: EsquireClient) {}

  public async send(): Promise<Passport|null> {
    const url = await this.client.fetchUrlFromSession("passport");

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "GET"
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      return null;
    }

    if (response.headers.get("content-length") === "0" || response.status === 204) {
      return null;
    }


    const result = await response.json() as PassportData | null;

    if (result === null) {
      return null;
    }
    return new Passport(result);
  }
}
